export function parseInfo(line) {
  if (!line.startsWith("info ")) {
    return null;
  }
  const depth = Number(line.match(/\bdepth (\d+)/)?.[1] ?? 0);
  const cp = line.match(/\bscore cp (-?\d+)/);
  const mate = line.match(/\bscore mate (-?\d+)/);
  const multipv = Number(line.match(/\bmultipv (\d+)/)?.[1] ?? 1);
  const pv = line.match(/\bpv (.+)$/)?.[1]?.split(/\s+/) ?? [];
  return {
    depth,
    score: cp
      ? { type: "cp", value: Number(cp[1]) }
      : mate
        ? { type: "mate", value: Number(mate[1]) }
        : null,
    multipv,
    pv,
  };
}

export function parseBestMove(line) {
  const match = line.match(/^bestmove\s+(\S+)/);
  if (!match) {
    return null;
  }
  return match[1] === "(none)" ? null : match[1];
}

export function uciToMove(uci) {
  if (!/^[a-h][1-8][a-h][1-8][qrbn]?$/.test(uci ?? "")) {
    return null;
  }
  return {
    from: uci.slice(0, 2),
    to: uci.slice(2, 4),
    ...(uci.length === 5 ? { promotion: uci[4] } : {}),
  };
}
